"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameof = void 0;
/**
 * This is for use where we need to use the name of a field, and want to ensure what we use is an actual field on the specified type.
 *
 * Same use case as the nameof keyword in C#
 *
 * e.g.
 * ```
 * type Example = {foo: string, bar: number};
 * nameof<Example>("foo"); //this will return "foo".
 * nameof<Example>("typo"); //this will cause a compiler error, as "typo" is not a key on Example.
 * ```
 * @param T the type to check validity of a field name on
 * @param name the name of a param on T
 * @returns name
 */
function nameof(name) {
    return name;
}
exports.nameof = nameof;
